import { TYPE } from "components/Form";
import { FLAG_FILTER_OPTIONS, GLOBAL_VALUE_TYPES, USER_TYPES_WITH_FILTER_ACCESS } from "constants/index";

// To avoid renaming all instances assigning USER_TYPES_WITH_FILTER_ACCESS to USER_TYPES
// For GSP-5251 to achieve e common way to use filters pattern across the application
const USER_TYPES = USER_TYPES_WITH_FILTER_ACCESS;

const APPLICANT_LIST_FILTERS_CONFIG = {
  application_pending_at: {
    label: "Pending At",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.dateValues,
    transformValues: ({ min, max }) => [min || null, max || null],
    properties: {
      component: TYPE.datePicker,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin],
    },
  },
  applied_at: {
    label: "Applied At",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.dateValues,
    transformValues: ({ min, max }) => [min || null, max || null],
    properties: {
      component: TYPE.datePicker,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin],
    },
  },
  application_progress_percentage: {
    label: "Application Progress Percentage",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  archetype: {
    label: "Archetype",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ archetype }) => archetype,
    showOperator: true,
    properties: {
      placeholder: "Type an archetype...",
      labelKey: "value",
      valueKey: "value",
      minLength: 1,
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  asking_hourly_rate_usd: {
    label: "Asking Hourly Rate (USD)",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  asking_hourly_rate_usd_minimum: {
    label: "Minimum Asking Hourly Rate (USD)",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  available_hours: {
    label: "Available Hours",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  considered_days_since_last_activity: {
    label: "Considered Days Since Last Activity",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  considered_experience_years: {
    label: "Considered Experience Years",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  considered_hourly_rate_usd: {
    label: "Considered Hourly Rate",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  considered_hourly_rate_usd_delta: {
    label: "Considered Hourly Rate Delta",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  considered_time_zone_offset: {
    label: "Considered Timezone Offset",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  continent: {
    label: "Continent",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ continent }) => continent,
    showOperator: true,
    properties: {
      placeholder: "Type a continent name...",
      labelKey: "value",
      valueKey: "value",
    },
    restrict: {
      roles: [USER_TYPES.admin, USER_TYPES.client, USER_TYPES.showcase],
    },
  },
  country: {
    label: "Country",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ country }) => country,
    showOperator: true,
    properties: {
      placeholder: "Type a country name...",
      labelKey: "value",
      valueKey: "value",
      minLength: 1,
    },
    restrict: {
      roles: [USER_TYPES.admin, USER_TYPES.client, USER_TYPES.showcase],
    },
  },
  days_since_application: {
    label: "Day(s) Since Application",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  days_since_invitation: {
    label: "Day(s) Since Invitation",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  days_since_last_activity: {
    label: "Day(s) Since Activity",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  disciplines: {
    label: "Disciplines",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ disciplines }) => disciplines,
    showOperator: true,
    properties: {
      placeholder: "Type a discipline...",
      labelKey: "value",
      valueKey: "value",
      minLength: 1,
    },
    restrict: {
      roles: [USER_TYPES.admin, USER_TYPES.client, USER_TYPES.showcase],
    },
  },
  email: {
    label: "Email",
    type: TYPE.input,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => [value],
    properties: {
      type: "email",
      withButton: true,
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  experience_years: {
    label: "Experience Years",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  has_accepted_all_requirements: {
    label: "Has accepted Requirements?",
    type: TYPE.select,
    valuesType: GLOBAL_VALUE_TYPES.flagValues,
    transformValues: (value) => [value],
    properties: {
      options: FLAG_FILTER_OPTIONS,
      isClearable: true,
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  has_completed_questionnaire: {
    label: "Has completed Questionnaire?",
    type: TYPE.select,
    valuesType: GLOBAL_VALUE_TYPES.flagValues,
    transformValues: (value) => [value],
    properties: {
      options: FLAG_FILTER_OPTIONS,
      isClearable: true,
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  has_completed_code_challenges: {
    label: "Has completed Code Challenges?",
    type: TYPE.select,
    valuesType: GLOBAL_VALUE_TYPES.flagValues,
    transformValues: (value) => [value],
    properties: {
      options: FLAG_FILTER_OPTIONS,
      isClearable: true,
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  has_completed_video_interview: {
    label: "Has completed Video Interview?",
    type: TYPE.select,
    valuesType: GLOBAL_VALUE_TYPES.flagValues,
    transformValues: (value) => [value],
    properties: {
      options: FLAG_FILTER_OPTIONS,
      isClearable: true,
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  has_completed_profile: {
    label: "Has completed Profile?",
    type: TYPE.select,
    valuesType: GLOBAL_VALUE_TYPES.flagValues,
    transformValues: (value) => [value],
    properties: {
      options: FLAG_FILTER_OPTIONS,
      isClearable: true,
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  has_provided_rate: {
    label: "Has provided Rate?",
    type: TYPE.select,
    valuesType: GLOBAL_VALUE_TYPES.flagValues,
    transformValues: (value) => [value],
    properties: {
      options: FLAG_FILTER_OPTIONS,
      isClearable: true,
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  has_applied_for_role: {
    label: "Has applied for Role?",
    type: TYPE.select,
    valuesType: GLOBAL_VALUE_TYPES.flagValues,
    transformValues: (value) => [value],
    properties: {
      options: FLAG_FILTER_OPTIONS,
      isClearable: true,
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  has_been_invited_to_role: {
    label: "Has been invited to Role?",
    type: TYPE.select,
    valuesType: GLOBAL_VALUE_TYPES.flagValues,
    transformValues: (value) => [value],
    properties: {
      options: FLAG_FILTER_OPTIONS,
      isClearable: true,
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  hourly_rate_usd: {
    label: "Hourly Rate (USD)",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  invited_at: {
    label: "Invited At",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.dateValues,
    transformValues: ({ min, max }) => [min || null, max || null],
    properties: {
      component: TYPE.datePicker,
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  is_assigned: {
    label: "Is Assigned?",
    type: TYPE.select,
    valuesType: GLOBAL_VALUE_TYPES.flagValues,
    transformValues: (value) => [value],
    properties: {
      options: FLAG_FILTER_OPTIONS,
      isClearable: true,
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  is_candidate: {
    label: "Is a Candidate?",
    type: TYPE.select,
    valuesType: GLOBAL_VALUE_TYPES.flagValues,
    transformValues: (value) => [value],
    properties: {
      options: FLAG_FILTER_OPTIONS,
      isClearable: true,
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  is_from_partner: {
    label: "Is coming from Partner?",
    type: TYPE.select,
    valuesType: GLOBAL_VALUE_TYPES.flagValues,
    transformValues: (value) => [value],
    properties: {
      options: FLAG_FILTER_OPTIONS,
      isClearable: true,
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  is_member: {
    label: "Is a Member?",
    type: TYPE.select,
    valuesType: GLOBAL_VALUE_TYPES.flagValues,
    transformValues: (value) => [value],
    properties: {
      options: FLAG_FILTER_OPTIONS,
      isClearable: true,
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  last_activity_at: {
    label: "Last Activity At",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.dateValues,
    transformValues: ({ min, max }) => [min || null, max || null],
    properties: {
      component: TYPE.datePicker,
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  lifetime_hourly_rate_usd: {
    label: "Lifetime Hourly Rate (USD)",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  lifetime_mission_count: {
    label: "Lifetime Mission Count",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  matching_skill_count: {
    label: "Matching Skills Count",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  matching_skill_count_optional: {
    label: "Matching Secondary Skills Count",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  matching_skill_count_required: {
    label: "Matching Required Skills Count",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  matching_skills_optional: {
    label: "Matching Secondary Skills",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ matchingSkillsOptional }) => matchingSkillsOptional,
    showOperator: true,
    properties: {
      label: "secondarySkills",
      placeholder: "Type a skill...",
      labelKey: "value",
      valueKey: "value",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  matching_skills_required: {
    label: "Matching Required Skills",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ matchingSkillsRequired }) => matchingSkillsRequired,
    showOperator: true,
    properties: {
      label: "requiredSkills",
      placeholder: "Type a skill...",
      labelKey: "value",
      valueKey: "value",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  match_score: {
    label: "Match Score",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  match_score_previous: {
    label: "Previous Match Score",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  matching_skills: {
    label: "Matching Skills",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ matchingSkills }) => matchingSkills,
    showOperator: true,
    properties: {
      label: "primarySkills",
      placeholder: "Type a skill...",
      labelKey: "value",
      valueKey: "value",
      minLength: 1,
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  mission_board_active_application_count: {
    label: "Active Application Count",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  mission_board_active_application_roles: {
    label: "Active Application Roles",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ missionBoardActiveApplicationRoles }) => missionBoardActiveApplicationRoles,
    showOperator: true,
    properties: {
      placeholder: "Type a name...",
      labelKey: "value",
      valueKey: "value",
      minLength: 1,
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  mission_board_invitation_conversion_rate: {
    label: "Invitation Conversion Rate",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  mission_role_applicant_notice_period: {
    label: "Applicant Notice Period",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ missionRoleApplicantNoticePeriod }) => missionRoleApplicantNoticePeriod,
    showOperator: true,
    properties: {
      placeholder: "Type the notice period...",
      labelKey: "value",
      valueKey: "value",
      minLength: 1,
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  mission_role_applicant_state: {
    label: "Applicant State",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ missionRoleApplicantState }) => missionRoleApplicantState,
    showOperator: true,
    properties: {
      placeholder: "Type a state...",
      labelKey: "value",
      valueKey: "value",
      minLength: 1,
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  mission_role_archetypes: {
    label: "Mission Role Archetype",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ missionRoleArchetypes }) => missionRoleArchetypes,
    showOperator: true,
    properties: {
      placeholder: "Type a archetype...",
      labelKey: "value",
      valueKey: "value",
      minLength: 1,
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  mission_role_skills: {
    label: "Mission Role Skills",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ missionRoleSkills }) => missionRoleSkills,
    showOperator: true,
    properties: {
      placeholder: "Type a skill...",
      labelKey: "value",
      valueKey: "value",
      minLength: 1,
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  mission_role_skills_optional: {
    label: "Mission Role Optional Skills",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ missionRoleSkillsOptional }) => missionRoleSkillsOptional,
    showOperator: true,
    properties: {
      placeholder: "Type a skill...",
      labelKey: "value",
      valueKey: "value",
      minLength: 1,
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  mission_role_skills_required: {
    label: "Mission Role Required Skills",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ missionRoleSkillsRequired }) => missionRoleSkillsRequired,
    showOperator: true,
    properties: {
      placeholder: "Type a skill...",
      labelKey: "value",
      valueKey: "value",
      minLength: 1,
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  mission_role_target_rate_usd: {
    label: "Mission Role Target Rate (USD)",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  mission_role_time_zone: {
    label: "Mission Role Timezone",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ missionRoleTimeZone }) => missionRoleTimeZone,
    showOperator: true,
    properties: {
      placeholder: "Type a time zone...",
      labelKey: "value",
      valueKey: "value",
      minLength: 1,
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  negotiated_hourly_rate_usd: {
    label: "Negotiated Hourly Rate (USD)",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  other_skill_count: {
    label: "Other Skills Count",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  other_skills: {
    label: "Other Skills",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ otherSkills }) => otherSkills,
    showOperator: true,
    properties: {
      placeholder: "Type a skill...",
      labelKey: "value",
      valueKey: "value",
      minLength: 1,
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  partner: {
    label: "Partner",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ partner }) => partner,
    showOperator: true,
    properties: {
      placeholder: "Type a name...",
      labelKey: "value",
      valueKey: "value",
      minLength: 1,
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  rate_score: {
    label: "Rate Score",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  rank_vector: {
    label: "Rank Vector",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  score_activity: {
    label: "Score Activity",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  score_experience: {
    label: "Score Experience",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  score_skills: {
    label: "Score Skills",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  score_time_zone: {
    label: "Score Time Zone",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  score_vector: {
    label: "Score Vector",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  selling_price_hourly_high_usd: {
    label: "Selling Price Hourly High (USD)",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  selling_price_hourly_low_usd: {
    label: "Selling Price Hourly Low (USD)",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  skills: {
    label: "Skills",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ skills }) => skills,
    showOperator: true,
    properties: {
      placeholder: "Type a skill...",
      labelKey: "value",
      valueKey: "value",
      minLength: 1,
    },
    restrict: {
      roles: [USER_TYPES.admin, USER_TYPES.client, USER_TYPES.showcase],
    },
  },
  talent_owner: {
    label: "Talent Owner (Role)",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ talentOwner }) => talentOwner,
    showOperator: true,
    properties: {
      placeholder: "Type a name...",
      labelKey: "value",
      valueKey: "value",
      minLength: 1,
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  time_zone: {
    label: "Time Zone",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ timeZone }) => timeZone,
    showOperator: true,
    properties: {
      placeholder: "Type a time zone...",
      labelKey: "value",
      valueKey: "value",
      minLength: 1,
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  weight_activity: {
    label: "Weight Activity",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  weight_experience: {
    label: "Weight Experience",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  weight_skills: {
    label: "Weight Skills",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  weight_time_zone: {
    label: "Weight Time Zone",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
  world_region: {
    label: "World Region",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ worldRegion }) => worldRegion,
    showOperator: true,
    properties: {
      placeholder: "Type a region...",
      labelKey: "value",
      valueKey: "value",
      minLength: 1,
    },
    restrict: {
      roles: [USER_TYPES.admin, USER_TYPES.client, USER_TYPES.showcase],
    },
  },
  weight_vector: {
    label: "Weight Vector",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    transformValues: ({ min, max }) => ({ min: parseFloat(min), max: parseFloat(max) }),
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES.admin],
    },
  },
};

const STICKY_FILTER_KEYS_FOR_CLIENTS = ["country", "disciplines", "skills", "world_region"];

export { STICKY_FILTER_KEYS_FOR_CLIENTS };

export default APPLICANT_LIST_FILTERS_CONFIG;
